import showSubscriptionModalApi from "api/contact/showSubscriptionModalApi";
import { setNewsLetterSubscription } from "../utils/setNewsLetterSubscription";

export function isNewsLetterSubscriptionNeededHandler() {
  return (dispatch: any) => {
    showSubscriptionModalApi()
      .then(({ data }) => {
        dispatch(setNewsLetterSubscription(data));
      });
  };
}
